import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import { Helmet } from 'react-helmet';

import {
  resetCustomer,
} from "../redux/customer/customer.actions";
import { selectCurrentCustomer } from "../redux/customer/customer.selectors";

import MiniCart from "../components/cart/mini-cart.component";
import Customer from "../components/customer/customer.comopnent";
import DeliveryMethod from '../components/shipping/delivery-method.component';
import PaymentMethod from '../components/payments/payment-method.component';
import { selectCurrentShipping } from "../redux/shipping/shipping.selectors";

import CheckoutRecovery from '../components/payments/recovery/checkout-recovery.component';
import { readAttempt } from '../components/payments/recovery/checkout-attempt';
import { setPaymentMethod } from '../redux/payment/payment.actions';

const Checkout = ({ customer, shipping, resetCustomer, setPaymentMethod }) => {
  const [recovery, setRecovery] = React.useState(() => {
    try { return { attempt: readAttempt() }; }
    catch (error) { return { error: error.message }; }
  });
  const retryDraft = () => {
    setPaymentMethod(recovery.attempt.method === 'stripe' ? 'card' : 'paypal');
    setRecovery({ attempt: null });
  };

  return (
    <main role="main" id="main">
      <Helmet>
        <title>Checkout | Trinity House</title>
      </Helmet>
    <div className="basket">
    <div className="container py-4">
      <div className="row">
        <div className="col-md-8">
            {recovery.error ? <p role="alert">{recovery.error}</p> : recovery.attempt ?
              <CheckoutRecovery attempt={recovery.attempt} retryDraft={retryDraft} released={() => setRecovery({ attempt: null })} /> :
              <><Customer /><DeliveryMethod />
                {shipping.set_deliveries || shipping.set_collection_option ? <PaymentMethod /> : ''}
              </>}

        </div>
        <div className="col-md-4">
          { <MiniCart /> }
        </div>
      </div>
    </div>
    </div>
    </main>
  );
};

const mapStateToProps = createStructuredSelector({
    customer: selectCurrentCustomer,
    shipping: selectCurrentShipping,

  });
  
  const mapDispatchToProps = (dispatch) => ({
    resetCustomer: () => dispatch(resetCustomer()),
    setPaymentMethod: method => dispatch(setPaymentMethod(method)),
  });
  
  export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(Checkout)
  );
  


